import has from 'lodash/has';
import get from 'lodash/get';

// -suggestionModel

const filterByTerm = (dataList, accessors, terms, returnDataCallback, matchAllAccessors = false) => {
    let filteredData = dataList;

    if (terms.length) {
        filteredData = filteredData.filter((item) => {
            let isMatch = matchAllAccessors ? true : false;
            let accessorsMatchingMap = {};
            accessors.forEach((accessor) => {
                accessorsMatchingMap[accessor] = false;
                if (has(item, accessor)) {
                    terms.forEach((term) => {
                        if(!accessorsMatchingMap[accessor]){
                            accessorsMatchingMap[accessor] = get(item, accessor).toLowerCase().includes(term);
                        }
                    });
                }
            });

            Object.keys(accessorsMatchingMap).forEach(key => {
                isMatch = matchAllAccessors ? isMatch && accessorsMatchingMap[key] : isMatch || accessorsMatchingMap[key];
            });

            return isMatch;
        });
    } else {
        filteredData = [];
    }

    returnDataCallback(filteredData, terms);
};

export const getSuggestionList = (dataList, idAccessor, accessors, component, returnDataCallback, matchAllAccessors = false) => {
    if (!dataList) return [];
    const suggestionsList = [];

    dataList.forEach((item) => {
        const suggestionTerms = [];

        accessors.forEach((accessor) => {
            const value = get(item, accessor);

            if (value) {
                suggestionTerms.push(value.toLowerCase());
            }
        });

        if (suggestionTerms.length) {
            const newId = get(item, idAccessor);
            const existingSuggestion = suggestionsList.some((suggestion) => suggestion.id === newId);
            if (!existingSuggestion) {
                suggestionsList.push({
                    id: newId,
                    term: suggestionTerms.join(' '),
                    suggestionComp: () => component(item),
                    callbackFunc: () => filterByTerm(dataList, accessors, suggestionTerms, returnDataCallback, matchAllAccessors)
                });
            }
        }
    });

    return suggestionsList;
};

export const getDefaultCallback = (dataList, accessors, returnDataCallback) => {
    return (terms) => filterByTerm(dataList, accessors, terms, returnDataCallback);
};
